const headerElm = document.querySelector('#mainheader');
const middleheaderEl = (headerElm) ? headerElm.querySelector('#middleheader'): null;
if( headerElm && middleheaderEl ){
  const headerHeight = middleheaderEl.offsetHeight;

  if(window.innerWidth < 992)
  {
    headerElm.classList.toggle('sticky',true );
  }
  else{
    if( headerHeight ){
      document.addEventListener("load", function() {
        headerElm.classList.toggle('sticky', ( document.documentElement.scrollTop >= headerElm.offsetHeight ) );
      });
      document.addEventListener("scroll", function() {
        headerElm.classList.toggle('sticky', ( document.documentElement.scrollTop >= headerElm.offsetHeight ) );
      });
    }
  }
}
